import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_URL } from 'config';
import { toast } from 'react-toastify';
import history from 'router/history';

export const client = axios.create({
  baseURL: API_URL,
});

function authRequestInterceptor(config: InternalAxiosRequestConfig<any>) {
  config.headers.Accept = 'application/json';
  // config.headers.Authorization = 'Bearer toto';
  return config;
}

client.interceptors.request.use(authRequestInterceptor);
client.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (401 === error.response.status) {
      history.replace('/logout');
      toast.error(
        "Votre authentification n'est plus valide, merci de vous reconnecter"
      );
      return Promise.reject(error);
    }
    const message = error.response?.data?.message || error.message;
    toast.error(message);
    return Promise.reject(error);
  }
);
